import type {
  AcceptInviteResponse,
  AcceptOrganizationJoinLinkRequest,
  OrganizationJoinLink,
  OrganizationJoinPreview,
} from '@kiao-voice/api-contract/organization'
import {
  getWebApiClient,
  getWebAuthedNoContextClient,
  getWebPublicApiClient,
} from '../../lib/web-api-client'

export function getJoinLink(organizationId: number): Promise<OrganizationJoinLink> {
  return getWebApiClient().request(`/api/v1/organizations/${organizationId}/join-link`, {
    cache: 'no-store',
  })
}
export function rotateJoinLink(organizationId: number): Promise<OrganizationJoinLink> {
  return getWebApiClient().request(`/api/v1/organizations/${organizationId}/join-link`, {
    method: 'POST',
  })
}
export function previewJoinLink(token: string): Promise<OrganizationJoinPreview> {
  return getWebPublicApiClient().request(
    `/api/v1/organizations/join-links/${encodeURIComponent(token)}`,
    { cache: 'no-store' }
  )
}
export function acceptJoinLink(token: string): Promise<AcceptInviteResponse> {
  const payload: AcceptOrganizationJoinLinkRequest = { token }
  return getWebAuthedNoContextClient().request('/api/v1/organizations/join-links/accept', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}
